import React, { memo } from "react";
import { Stack, Typography, useTheme } from "@mui/material";
import { MdCheck } from "@react-icons/all-files/md/MdCheck";
import { BiErrorCircle } from "@react-icons/all-files/bi/BiErrorCircle";
import { IconContainer } from "./messageViewer.styles";

interface IMessageViewer {
  /**
   * text message.
   */
  details?: string;
  /**
   * Extra details which will in highted.
   */
  extraDetails?: string;
  /**
   * Status of the message.(They will be color coded)
   * @default success
   */
  status?: "error" | "success";
}

function MessageViewer({
  details,
  extraDetails,
  status = "success",
}: IMessageViewer) {
  const theme = useTheme();
  return (
    <Stack
      direction={"row"}
      columnGap={0.5}
      sx={{
        color:
          status === "error"
            ? theme.palette.error.main
            : theme.palette.success.main,
      }}
    >
      <IconContainer>
        {status === "error" ? (
          <BiErrorCircle size={15} />
        ) : (
          <MdCheck size={15} />
        )}
      </IconContainer>
      <div>
        <Typography>{details}</Typography>
        <Typography fontWeight={"bold"}>{extraDetails}</Typography>
      </div>
    </Stack>
  );
}

export default memo(MessageViewer);
